import React, { Component } from 'react';
import * as Sentry from '@sentry/react';

import { translate } from '@chaika/i18n/helper';

interface Props {
    children: React.ReactElement<any> | number | string;
}

interface State {
    hasError: boolean;
    error: any;
}

export class ErrorBoundary extends Component<Props> {
    public static getDerivedStateFromError(error: any) {
        return { hasError: true, error };
    }

    public state: State;

    public constructor(props: any) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    public componentDidCatch(error: any) {
        Sentry.captureException(error);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h1>{translate('somethingWentWrong')}</h1>
                    <p style={{ fontWeight: 'bold', paddingBottom: '20px' }}>
                        {this.state.error?.message || translate('errorOccured')}
                    </p>
                    <p style={{ whiteSpace: 'pre' }}>{this.state.error?.stack || '-'}</p>
                </div>
            );
        }

        return this.props.children;
    }
}
